const _ = "skeleton-loader", R = "main", t = "packs", O = "strict", s = "trash", A = "back";
export {
  A as FORMA_FOLDER_ID_BACK,
  t as FORMA_FOLDER_ID_PACKS,
  R as FORMA_FOLDER_ID_STATIC,
  O as FORMA_FOLDER_ID_STRICT,
  s as FORMA_FOLDER_ID_TRASH,
  _ as SKELETON_CLASS
};
